/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {WhatsApp} from "@mui/icons-material";
import {irUrl} from "../../../../Utilidades/irUrl";
import {LINKWHATSAPP} from "../../../../Constantes";

const Propuesta_Valor_Portada_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        color: 'white',
                        fontSize: sCell ? 32 : 54,
                        fontWeight: 900,
                        textAlign: sCell ? 'center' : 'flex-start',
                        width: "100%",
                        lineHeight: 1.1
                    }}>
                    ¿Necesitas tus exámenes ocupacionales

                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: sCell ? 32 : 54,
                            fontWeight: 900,
                            width: "100%",
                            lineHeight: 1.1
                        }}
                    >
                        para trabajar?
                    </Typography>
                </Typography>
            </Grid2>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        textAlign: sCell ? 'center' : 'flex-start',
                        fontSize: 18,
                        color: 'white',
                        pt: 2
                    }}>
                    Somos una institución privada con sentido social que presta servicios de salud y seguridad en el
                    trabajo, apoyando al sector empresarial privado y público.
                </Typography>
            </Grid2>


            <Grid2 container size={{xs: 12, sm: 12, md: 12}}
                   sx={{marginTop: 6, justifyContent: sCell ? 'center' : 'flex-start'}}>
                <Button
                    onClick={() => irUrl(LINKWHATSAPP)}
                    sx={{color: '#fff'}} startIcon={<WhatsApp sx={{fill: '#fff'}}/>}>Más información</Button>
            </Grid2>

        </Grid2>
    )

}
export default Propuesta_Valor_Portada_Home;